<div class="flex justify-between items-center">
  <div>
    <h1 class="app mb-2">{{ this.agencyName() }}</h1>
    <lib-button
      [text]="'Back to Agencies'"
      [cssType]="'btn-link'"
      [icon]="'circleleft'"
      (click)="goBack()"
    ></lib-button>
  </div>
  <lib-button [text]="'Add Users'" [icon]="'rightarrow'" (click)="addUsers()"></lib-button>
</div>
<lib-toolbar [tiles]="toolbarTiles()" [layout]="'column'"></lib-toolbar>
<mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">
  <mat-tab label="COMPANY">
    <lib-agency></lib-agency>
  </mat-tab>
  <mat-tab label="USERS">
    <lib-users-grid [refresh]="refresh()" [agencyId]="agencyId()" (modalClose)="refreshGrid($event)"></lib-users-grid>
  </mat-tab>
</mat-tab-group>
